import React from 'react';
import { motion } from 'framer-motion';
import { Check, Database, Search, Clock } from 'lucide-react';
import { Button } from './ui/Button';
export function Pricing() {
  return <section id="pricing" className="py-24 bg-white" data-id="element-145">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-146">
        <div className="text-center mb-16" data-id="element-147">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-slate-900 mb-4" data-id="element-148">
            Transparent Pricing
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-149">
            Simple, time-based pricing. No hidden fees or per-document charges.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-150">
          {/* Card 1: Initial Analysis */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="flex flex-col bg-white rounded-2xl border border-slate-200 shadow-sm hover:shadow-md transition-shadow p-8" data-id="element-151">
            <div className="mb-6" data-id="element-152">
              <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-153">
                Initial Analysis
              </h3>
              <p className="text-sm text-slate-500" data-id="element-154">Comprehensive first pass</p>
            </div>
            <div className="mb-6" data-id="element-155">
              <div className="flex items-baseline" data-id="element-156">
                <span className="text-4xl font-bold text-slate-900" data-id="element-157">$400</span>
                <span className="text-slate-500 ml-2" data-id="element-158">/ hour</span>
              </div>
              <p className="text-sm text-slate-600 mt-2" data-id="element-159">
                Typical case: 10-12 hours
                <br data-id="element-160" />
                ($4,000 - $4,800)
              </p>
            </div>
            <ul className="space-y-4 mb-8 flex-1" data-id="element-161">
              <li className="flex items-start" data-id="element-162">
                <Check className="h-5 w-5 text-amber-500 mr-3 flex-shrink-0" data-id="element-163" />
                <span className="text-slate-600 text-sm" data-id="element-164">
                  Processing & Ingestion
                </span>
              </li>
              <li className="flex items-start" data-id="element-165">
                <Check className="h-5 w-5 text-amber-500 mr-3 flex-shrink-0" data-id="element-166" />
                <span className="text-slate-600 text-sm" data-id="element-167">
                  AI Analysis of all docs
                </span>
              </li>
              <li className="flex items-start" data-id="element-168">
                <Check className="h-5 w-5 text-amber-500 mr-3 flex-shrink-0" data-id="element-169" />
                <span className="text-slate-600 text-sm" data-id="element-170">
                  Quality Assurance Review
                </span>
              </li>
              <li className="flex items-start" data-id="element-171">
                <Check className="h-5 w-5 text-amber-500 mr-3 flex-shrink-0" data-id="element-172" />
                <span className="text-slate-600 text-sm" data-id="element-173">Excel Delivery</span>
              </li>
            </ul>
            <Button variant="outline" className="w-full" data-id="element-174">
              Get Estimate
            </Button>
          </motion.div>

          {/* Card 2: Web Platform (Featured) */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex flex-col bg-slate-900 rounded-2xl border border-slate-800 shadow-xl p-8 relative scale-105 z-10" data-id="element-175">
            <div className="absolute top-0 right-0 bg-amber-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg rounded-tr-lg" data-id="element-176">
              POPULAR
            </div>
            <div className="mb-6" data-id="element-177">
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-178">
                Web Platform
              </h3>
              <p className="text-sm text-slate-400" data-id="element-179">
                Collaborative review interface
              </p>
            </div>
            <div className="mb-6" data-id="element-180">
              <div className="flex items-baseline" data-id="element-181">
                <span className="text-4xl font-bold text-white" data-id="element-182">$250</span>
                <span className="text-slate-400 ml-2" data-id="element-183">/ month</span>
              </div>
              <p className="text-sm text-slate-400 mt-2" data-id="element-184">
                + $2,000 one-time setup
              </p>
            </div>
            <ul className="space-y-4 mb-8 flex-1" data-id="element-185">
              <li className="flex items-start" data-id="element-186">
                <Database className="h-5 w-5 text-amber-500 mr-3 flex-shrink-0" data-id="element-187" />
                <span className="text-slate-300 text-sm" data-id="element-188">
                  Lifetime storage included
                </span>
              </li>
              <li className="flex items-start" data-id="element-189">
                <Search className="h-5 w-5 text-amber-500 mr-3 flex-shrink-0" data-id="element-190" />
                <span className="text-slate-300 text-sm" data-id="element-191">
                  Search, filter, tag & annotate
                </span>
              </li>
              <li className="flex items-start" data-id="element-192">
                <Check className="h-5 w-5 text-amber-500 mr-3 flex-shrink-0" data-id="element-193" />
                <span className="text-slate-300 text-sm" data-id="element-194">
                  Unlimited user access
                </span>
              </li>
              <li className="flex items-start" data-id="element-195">
                <Check className="h-5 w-5 text-amber-500 mr-3 flex-shrink-0" data-id="element-196" />
                <span className="text-slate-300 text-sm" data-id="element-197">
                  Export to Excel anytime
                </span>
              </li>
            </ul>
            <Button variant="primary" className="w-full" data-id="element-198">
              Request Demo
            </Button>
          </motion.div>

          {/* Card 3: Additional Passes */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="flex flex-col bg-white rounded-2xl border border-slate-200 shadow-sm hover:shadow-md transition-shadow p-8" data-id="element-199">
            <div className="mb-6" data-id="element-200">
              <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-201">
                Targeted Passes
              </h3>
              <p className="text-sm text-slate-500" data-id="element-202">Deep dive analysis</p>
            </div>
            <div className="mb-6" data-id="element-203">
              <div className="flex items-baseline" data-id="element-204">
                <span className="text-4xl font-bold text-slate-900" data-id="element-205">$400</span>
                <span className="text-slate-500 ml-2" data-id="element-206">/ hour</span>
              </div>
              <p className="text-sm text-slate-600 mt-2" data-id="element-207">
                Typical pass: 3-5 hours
                <br data-id="element-208" />
                Custom prompts
              </p>
            </div>
            <ul className="space-y-4 mb-8 flex-1" data-id="element-209">
              <li className="flex items-start" data-id="element-210">
                <Clock className="h-5 w-5 text-amber-500 mr-3 flex-shrink-0" data-id="element-211" />
                <span className="text-slate-600 text-sm" data-id="element-212">Fast turnaround</span>
              </li>
              <li className="flex items-start" data-id="element-213">
                <Check className="h-5 w-5 text-amber-500 mr-3 flex-shrink-0" data-id="element-214" />
                <span className="text-slate-600 text-sm" data-id="element-215">
                  "Find all docs related to..."
                </span>
              </li>
              <li className="flex items-start" data-id="element-216">
                <Check className="h-5 w-5 text-amber-500 mr-3 flex-shrink-0" data-id="element-217" />
                <span className="text-slate-600 text-sm" data-id="element-218">
                  "Identify communications between..."
                </span>
              </li>
              <li className="flex items-start" data-id="element-219">
                <Check className="h-5 w-5 text-amber-500 mr-3 flex-shrink-0" data-id="element-220" />
                <span className="text-slate-600 text-sm" data-id="element-221">
                  Updated Excel delivery
                </span>
              </li>
            </ul>
            <Button variant="outline" className="w-full" data-id="element-222">
              Learn More
            </Button>
          </motion.div>
        </div>

        <div className="mt-12 text-center" data-id="element-223">
          <p className="text-slate-500 text-sm" data-id="element-224">
            Platform integration available: Output can be formatted for
            Relativity, Everlaw, Disco, etc.
          </p>
        </div>
      </div>
    </section>;
}